export default __webpack_public_path__ + "static/burring-c43b3ed41e06460aba83d55551470a08.png";